import { cn } from "@/core/helpers/cn";

type Props = {
  className?: string;
};

export default function Loader({ className }: Props) {
  return (
    <div
      className={cn(
        "absolute z-10 top-1/2 left-1/2 flex items-center justify-center p-4 -translate-x-1/2 -translate-y-1/2",
        className,
      )}
    >
      <div className="mz-loader" />
    </div>
  );
}
